import '@fortawesome/fontawesome-free/css/all.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

import colors from 'vuetify/lib/util/colors';

export default new Vuetify({
    icons: {
        iconfont: 'fa',
    },
    theme: {
        dark: false,
        themes: {
            light: {
                base: "#020F2A",
                primary: "#020F2A",
                secondary: "#3f66b7",
            },
            dark: {
                base: "#020F2A",
                primary: "#020F2A",
                secondary: "#3f66b7",
            },
        },
    },
});
